import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { registerPlugin } from "react-filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import { AudioAPI, AudioEdit, GetQrLink } from "../../../redux/requests/audio";
import { preloaderToggle } from "../../../redux/slices/preloader";
import { navigationStep } from "../../../redux/slices/navigation";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import StepCustomize from "../../../components/stepCustomize";
import { Context } from "../../../components/saveFile/saveFile";
import QrTitleField from "../../../components/input/qrTitleField";
import { getFileFromUrl, isNoEditRoute } from "../../../hooks/helpers";
import axios from "axios";
import { setCategory } from "../../../redux/slices/selectCategories";
import Form from "react-bootstrap/Form";
import { SelectCategory } from "../../../components";
import FileUpload from "../../../components/input/fileUpload";
import { setIsStorageModal } from "../../../redux/slices/modals";
import { handleFilesUpdate } from "../../../hooks/helpers";
import usePremium from "../../../hooks/usePremium";
import useTypeDecription from "../../../hooks/useTypeDecription";
import { useDebouncedCallback } from "use-debounce";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
import useUserInfo from "../../../hooks/useUserInfo";

export default function AudioPage() {
  const { lang, getQrLinkSlice, categoryChange, valueNameQr, toggle } =
    useSelector((state) => ({
      lang: state.changeLang.language.stepTwo.audio,
      getQrLinkSlice: state.getQrLinkSlice,
      categoryChange: state.categories.categoryChange,
      valueNameQr: state.saveValue.valueNameQr,
      toggle: state.preloader.toggle,
    }));
  const { id } = useParams();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const debouncedHandleFilesUpdate = useDebouncedCallback(
    handleFilesUpdate,
    500
  );
  const { isPremium } = usePremium();
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();

  const { saveAudio, setSaveAudio } = useContext(Context);
  const [qrTitle, setQrTitle] = useState(valueNameQr);
  const [audio, setAudio] = useState("");
  const [errorFileMessage, setErrorFileMessage] = useState("");
  const { isAdmin } = useUserInfo();

  const maxFileSize = isAdmin ? null : isPremium ? 99 : 30;

  registerPlugin(
    FilePondPluginFileValidateSize,
    FilePondPluginFileValidateType
  );

  useEffect(() => {
    getContent("audio");
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/entry/file/get/${id}`)
        .then(({ data }) => {
          setQrTitle(data.qrTitle);
          dispatch(setCategory(data.adsCategories));
          data.link &&
            getFileFromUrl(data.link, "file").then((file) => setAudio([file]));
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  function step() {
    if (
      !!audio &&
      (isAdmin || audio[0]?.file.size <= maxFileSize * 1024 * 1024) &&
      !!getQrLinkSlice.id === false &&
      !id
    ) {
      dispatch(
        GetQrLink(() => AudioAPI([audio[0].file, categoryChange, qrTitle]))
      );
    } else if (getQrLinkSlice.id || id) {
      dispatch(
        GetQrLink(() =>
          AudioEdit([
            getQrLinkSlice.id || id,
            audio[0]?.file,
            categoryChange,
            qrTitle,
          ])
        )
      );
    }
    dispatch(preloaderToggle(true));
  }

  useEffect(() => {
    setAudio(saveAudio);
  }, [saveAudio]);

  useEffect(() => {
    if (
      getQrLinkSlice.status === "success" &&
      !!getQrLinkSlice.link &&
      toggle
    ) {
      if (isNoEditRoute) {
        dispatch(navigationStep(3));
        setSaveAudio(audio);
        navigate("/qr");
      } else {
        window.location.href = adminEntryLocation;
      }
    } else if (getQrLinkSlice.status === "failed") {
      dispatch(preloaderToggle(false));
    }
  }, [getQrLinkSlice.status]);

  return (
    <>
      {isNoEditRoute && <Navigation />}
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <FileUpload
            files={audio}
            onupdatefiles={(files) => {
              setErrorFileMessage("");
              debouncedHandleFilesUpdate(
                files,
                setAudio,
                () => dispatch(setIsStorageModal(true)),
                !isAdmin
              );
            }}
            allowFileTypeValidation={true}
            maxFileSize={maxFileSize ? `${maxFileSize}MB` : null}
            allowMultiple={false}
            maxFiles={1}
            name="audioFile"
            acceptedFileTypes={[
              "audio/m4a",
              "audio/x-flac,audio/flac",
              "audio/mpeg",
              "audio/mp4",
              "audio/x-wav",
              "audio/x-ms-wma",
              "audio/aac",
              "video/mp4",
              "audio/wav",
              "audio/x-m4a",
              "application/octet-stream",
            ]}
            label={lang[0]}
            popoverText={lang[19]}
            onerror={(e) => setErrorFileMessage(e)}
          />
          {errorFileMessage && (
            <Form.Text className="text-danger">{errorFileMessage}</Form.Text>
          )}

          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>
        <SelectCategory />

        <StepCustomize
          emulate={step}
          disabled={
            !audio ||
            !audio.length ||
            (!isAdmin && audio[0]?.file?.size > maxFileSize * 1024 * 1024) ||
            errorFileMessage
          }
        />
      </SecondScreen>
      {isNoEditRoute && content}
    </>
  );
}
